import TabPageContainer from '~components/atoms/TabPageContainer';
import StockOutApprovalSearchAndFilterBar from './StockOutApprovalSearchAndFilterBar';
import StockOutApprovalTable from './StockOutApprovalTable';
import StockOutApprovalPaginator from './StockOutApprovalPaginator';
import ConfirmUpdateStockOutStatusModal from './ConfirmUpdateStockOutStatusModal';

const StockOutApproval = () => {
    return (
        <TabPageContainer>
            <StockOutApprovalSearchAndFilterBar />

            <StockOutApprovalTable />

            <StockOutApprovalPaginator />

            <ConfirmUpdateStockOutStatusModal />
        </TabPageContainer>
    );
};

export default StockOutApproval;
